<!--<button class="btn btn-primary q-filter__hide" (click)="togglefilter(filterSection, btnShowFilter)" #btnShowFilter>Show filter</button>-->

<div class="q-filter" #filterSection>
  <div class="q-filter__body" [formGroup]="ConditionForm">
    <div class="btn-line">
      <!--<button class="btn btn-primary q-filter__hide" (click)="togglefilter(filterSection, btnShowFilter)">Hide filter</button>-->
      <button
        class="btn btn-primary"
        [ngClass]="{ disabled: this.formOperatorsList.length === 0 }"
        (click)="resetFilter()"
      >
        Reset all filters
      </button>
      <div class="ml-a">
        <button
          class="btn btn-success q-filter__add"
          [ngClass]="{ disabled: this.formOperatorsList.length >= this.conditionLimit }"
          (click)="addCondition()"
        >
          Add new condition
        </button>
        <button
          class="btn btn-primary q-filter__submit"
          [ngClass]="{ disabled: !this.isFilterCanApply() }"
          (click)="applyFilter()"
        >
          Apply filter
        </button>
      </div>
    </div>

    <div formArrayName="FConditions">
      <div class="q-filter__condition">
        <div class="q-filter__form-control-row">
          <div class="q-filter__form-control q-filter__condition-operator">
            <label class="q-filter__label">
              <!--<span class="q-filter__control-name">Operator</span>-->
            </label>
          </div>
          <div class="q-filter__form-control q-filter__condition-field">
            <label class="q-filter__label">
              <span class="q-filter__control-name">Field</span>
            </label>
          </div>
          <div class="q-filter__form-control q-filter__condition-relation">
            <label class="q-filter__label">
              <span class="q-filter__control-name">Relation</span>
            </label>
          </div>
          <div class="q-filter__form-control q-filter__condition-value">
            <label class="q-filter__label">
              <span class="q-filter__control-name">Value</span>
            </label>
          </div>
          <div class="q-filter__form-control q-filter__condition-btn"></div>
        </div>
      </div>

      <div class="q-filter__condition-list">
        <ng-container *ngFor="let condition of conditionsFormArray().controls; let idx = index">
          <div class="q-filter__condition" [formGroupName]="idx">
            <div class="q-filter__form-control-row">
              <div class="q-filter__form-control q-filter__condition-operator y-offset">
                <div class="like-select" #suggestionOperatorSelector [hidden]="idx === 0">
                  <input
                    #operatorInput
                    type="text"
                    formControlName="{{ INPUT_NAMES.operator }}"
                    class="q-filter__input full-width"
                    value="AND"
                    (click)="suggestionOperatorSelector.classList.add('open')"
                    (blur)="
                      onBlurSuggestionInputHandler(
                        idx,
                        condition,
                        operatorInput,
                        INPUT_NAMES.operator,
                        suggestionOperatorSelector,
                        operatorsSuggestionList,
                        OPERATOR_SELECTORS_LIST.AND
                      )
                    "
                  />
                  <div class="like-select__options">
                    <span
                      *ngFor="let operatorValue of operatorsSuggestionList"
                      (click)="chooseSelectedValue(operatorValue, suggestionOperatorSelector, operatorInput)"
                      title="{{ operatorValue }}"
                      class="like-select__option"
                    >
                      {{ operatorValue }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="q-filter__form-control q-filter__condition-field">
                <div class="like-select" #suggestionFieldNameSelector>
                  <input
                    #fieldNameInput
                    type="text"
                    class="q-filter__input full-width"
                    placeholder="Field"
                    formControlName="{{ INPUT_NAMES.fieldName }}"
                    (click)="openSuggestionList(suggestionFieldNameSelector)"
                    (input)="changeFieldNameHandler(idx, fieldNameInput)"
                    (blur)="
                      onBlurSuggestionInputHandler(
                        idx,
                        condition,
                        fieldNameInput,
                        INPUT_NAMES.fieldName,
                        suggestionFieldNameSelector,
                        filteredRecordFieldsSuggestionLists[idx],
                        ''
                      )
                    "
                  />
                  <div class="like-select__options" *ngIf="filteredRecordFieldsSuggestionLists[idx].length">
                    <span
                      *ngFor="let field of filteredRecordFieldsSuggestionLists[idx]"
                      (click)="chooseSelectedValue(field.name, suggestionFieldNameSelector, fieldNameInput)"
                      title="{{ field.name }}"
                      class="like-select__option"
                    >
                      {{ field.name }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="q-filter__form-control q-filter__condition-relation">
                <div class="like-select" #suggestionRelationsSelector>
                  <input
                    #relationInput
                    type="text"
                    class="q-filter__input full-width"
                    placeholder="equal"
                    formControlName="{{ INPUT_NAMES.relation }}"
                    (click)="openSuggestionList(suggestionRelationsSelector)"
                    (input)="changeFieldNameHandler(relationInput)"
                    (blur)="
                      onBlurSuggestionInputHandler(
                        idx,
                        condition,
                        relationInput,
                        INPUT_NAMES.relation,
                        suggestionRelationsSelector,
                        allRelationsSelectList,
                        RELATION_TYPES.equals
                      )
                    "
                  />
                  <div class="like-select__options" *ngIf="allRelationsSelectList.length">
                    <span
                      *ngFor="let relValue of allRelationsSelectList"
                      (click)="chooseSelectedValue(relValue, suggestionRelationsSelector, relationInput)"
                      title="{{ relValue }}"
                      class="like-select__option"
                    >
                      {{ relValue }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="q-filter__form-control q-filter__condition-value">
                <input
                  type="text"
                  class="q-filter__input full-width"
                  placeholder="type your value"
                  formControlName="value"
                />
              </div>

              <div class="q-filter__form-control q-filter__condition-btn">
                <button class="btn btn-primary delete-btn no-margin" (click)="deleteCondition(idx)">
                  <span class="glyphicon glyphicon-trash" title="delete condition"></span>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
